import { get } from '@/api'
import Vue from 'vue'
import NormalizationWorker from 'worker-loader?name=normalization.worker.js!../../utils/normalization.worker.js'
import PromiseWorker from '@/utils/PromiseWorker'

function generateIndex(collection) {
  return collection.reduce((accumulator, item, index) => {
    accumulator[item.id] = index
    return accumulator
  }, {})
}

export default {
  namespaced: true,
  state: {
    menu: null
  },
  mutations: {
    SET_MENU(state, menu) {
      Vue.set(state, 'menu', menu)
    }
  },
  actions: {
    async FETCH({ state, commit }) {
      if (state.menu) {
        return state.menu
      }
      try {
        const json = await get(`takeaway-menu`)
        const { buns, patties, ingredients, fryings, product_categories } = json.data
        const [burgers, burger_bowls] = json.data.burgers.reduce(
          (acc, item) => {
            if (item.has_buns) {
              acc[0].push(item)
            } else {
              acc[1].push(item)
            }
            acc.push(item)
            return acc
          },
          [[], []]
        )
        const products = json.data.products.filter(product => product.is_available_in_app === true)
        const normalizeWorker = new PromiseWorker(new NormalizationWorker())
        const [
          ingredientsNormalized,
          bunsNormalized,
          pattiesNormalized,
          fryingsNormalized
        ] = await Promise.all([
          normalizeWorker.postMessage(ingredients),
          normalizeWorker.postMessage(buns),
          normalizeWorker.postMessage(patties),
          normalizeWorker.postMessage(fryings)
        ])
        const menu = {
          burgers,
          burger_bowls,
          products,
          products_index: generateIndex(products),
          buns: bunsNormalized,
          patties: pattiesNormalized,
          ingredients: ingredientsNormalized,
          fryings: fryingsNormalized,
          product_categories: product_categories
        }
        commit('SET_MENU', menu)

        return menu
      } catch (error) {
        throw error
      }
    }
  }
}
